__turbopack_context__.v({
  "actions": "cart-drawer-line-module__6jhJcW__actions",
  "bottomRow": "cart-drawer-line-module__6jhJcW__bottomRow",
  "bundleLabel": "cart-drawer-line-module__6jhJcW__bundleLabel",
  "compareAt": "cart-drawer-line-module__6jhJcW__compareAt",
  "content": "cart-drawer-line-module__6jhJcW__content",
  "effective": "cart-drawer-line-module__6jhJcW__effective",
  "grid": "cart-drawer-line-module__6jhJcW__grid",
  "headingRow": "cart-drawer-line-module__6jhJcW__headingRow",
  "image": "cart-drawer-line-module__6jhJcW__image",
  "imageLink": "cart-drawer-line-module__6jhJcW__imageLink",
  "line": "cart-drawer-line-module__6jhJcW__line",
  "meta": "cart-drawer-line-module__6jhJcW__meta",
  "options": "cart-drawer-line-module__6jhJcW__options",
  "prices": "cart-drawer-line-module__6jhJcW__prices",
  "remove": "cart-drawer-line-module__6jhJcW__remove",
  "rowError": "cart-drawer-line-module__6jhJcW__rowError",
  "savings": "cart-drawer-line-module__6jhJcW__savings",
  "title": "cart-drawer-line-module__6jhJcW__title",
  "titleLink": "cart-drawer-line-module__6jhJcW__titleLink",
});
